import { mapState } from "vuex";

import {
  META_USER_MESSAGES,
  SETTING_CHANGE_SHOW_USER_MESSAGE
} from "@/util/mutationTypes";

export default {
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      hasShowUserMessage: state => state.SettingStorage.hasShowUserMessage,
      userMessages: state => state.MetadataStorage.userMessages,
      hasQueryUserMessage: state => state.MetadataStorage.hasQueryUserMessage
    }),
    message() {
      let result = null;

      let msg = this.userMessages.filter(m => !m.category);

      if (msg.length) {
        result = msg[0];
      }

      return result;
    },
    isShowMessage() {
      return !this.hasShowUserMessage && this.message;
    }
  },
  methods: {
    show() {
      if (this.isShowMessage) {
        if (this.message.component == "modal") {
          this.showModalWindow();
        } else if (this.message.component == "popup") {
          this.showPopupWindow();
        }
      }
    },
    showModalWindow() {
      if (this.isShowMessage) {
        this.$confirm(this.message.text, this.message.title, {
          confirmButtonText: "OK",
          dangerouslyUseHTMLString: true,
          type: this.message.messageType,
          showCancelButton: false
        }).then(() => {
          this.hideUserMessage();
        });
      }
    },
    showPopupWindow() {
      if (this.isShowMessage) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: this.message.text,
          type: this.message.messageType,
          showClose: true
        });
        this.hideUserMessage();
      }
    },
    hideUserMessage() {
      this.$store.commit(SETTING_CHANGE_SHOW_USER_MESSAGE, true);
    }
  },
  mounted() {
    if (!this.hasQueryUserMessage) {
      this.$store.dispatch(META_USER_MESSAGES);
    } else {
      this.show();
    }
  },
  watch: {
    userMessages: function () {
      this.show();
    }
  }
};
